/// <reference path='../_all.ts' />

module product_references {
  'use strict';

  export class Product {
    public Id: number;
    public Name: string;
  }

}


